import { ncpdpIdScalar } from "./ncpdp-id.scalar.js";
import { ndcScalar } from "./ndc.scalar.js";
import { npiScalar } from "./npi.scalar.js";
import { GraphQLScalarType } from "graphql";
import { resolvers } from "graphql-scalars";

//#region src/custom-scalars/scalar.resolvers.ts
const scalarResolvers = {
	...resolvers,
	NCPDPID: ncpdpIdScalar,
	NDC: ndcScalar,
	NPI: npiScalar
};

//#endregion
export { scalarResolvers };